import React from 'react';
import classNames from 'classnames';

const Input = ({
  name,
  value,
  onChange,
  type,
  required,
  labelName,
  className,
  styleOverride,
  disabled,
}) => {
  return (
    <div className={classNames('input', className)}>
      <input
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        required={required}
        className="input__element"
        style={{ padding: '1rem' }}
        disabled={disabled ?? false}
      />
      <span className="input__highlight" />
      <span className="input__bar"/>
      <label className="input__label" style={{...styleOverride}}>{labelName}</label>
    </div>
  );
};

export default Input;
